import { Button, Alert } from '@cinesend/ui-kit'
import { ArrowsClockwise } from '@phosphor-icons/react'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import Details from './details'
import useStore from '../../hooks/use_store'
import Page from '../../components/layouts/page'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'
import { useEffect, useRef } from 'react'
import InterstitalAdsTable from './cycle_interstitial_ads_table'
import { useSnackbar } from '../../hooks/use_snackbar'

const Cycle = () => {
  const { updateModel } = useStore()
  const params = useParams()
  const queryClient = useQueryClient()
  const { addMessage } = useSnackbar()
  const wasAutofilling = useRef(false)

  const {
    data: cycle,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['cycles/', params.cycleID],
    refetchInterval: (data) => (data?.is_autofilling ? 2000 : false),
    refetchIntervalInBackground: false,
  })

  const { canEditModel: canEditCycle } = useAuth(modelTypes.Cycle, cycle)

  useEffect(() => {
    wasAutofilling.current = false
  }, [params.cycleID])

  useEffect(() => {
    if (wasAutofilling.current && cycle && !cycle.is_autofilling) {
      queryClient.invalidateQueries(['cycles/'])
      addMessage('Auto-fill complete')
    }
    if (cycle) {
      wasAutofilling.current = !!cycle.is_autofilling
    }
  }, [cycle?.is_autofilling])

  const isAutofilling = updateModel.isLoading || !!cycle?.is_autofilling

  return (
    <Page
      title='Setup'
      pending={isLoading}
      error={error}
      buttons={[
        canEditCycle && (
          <Button
            key={cycle?.id + 'autorenew'}
            variant='secondary'
            trailingIcon={<ArrowsClockwise size={20} />}
            loading={isAutofilling}
            onClick={() =>
              updateModel.mutate({
                endpoint: 'cycles',
                id: params.cycleID + '/auto-fill',
                silent: true,
              })
            }
          >
            Auto-fill
          </Button>
        ),
      ].filter(Boolean)}
    >
      {cycle ? (
        <div className='flex w-full max-w-4xl flex-col gap-12'>
          <Details cycle={cycle} />
          {cycle.issues?.length > 0 && (
            <Alert tone='error' size='sm'>
              <ul className={cycle.issues.length > 1 ? 'list-disc list-inside' : 'list-none'}>
                {cycle.issues.map((issue) => (
                  <li key={issue.id}>{issue.description}</li>
                ))}
              </ul>
            </Alert>
          )}
          <InterstitalAdsTable cycle={cycle} />
        </div>
      ) : null}
    </Page>
  )
}

export default Cycle
